import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm14.261 6.442-.73.27V12.8a.75.75 0 0 1-1.5 0V7.252l-1.69.62V12.8a.75.75 0 0 1-1.5 0V8.412l-1.7.62V12.8a.75.75 0 0 1-1.5 0V9.582l-1.7.62v2.6a.75.75 0 0 1-1.5 0v-2.06l-.19.07a.742.742 0 0 1-.25.05.753.753 0 0 1-.26-1.46l.7-.25V3.2a.75.75 0 0 1 1.5 0v5.4l1.7-.62V3.2a.75.75 0 0 1 1.5 0v4.23l1.7-.62V3.2a.75.75 0 0 1 1.5 0v3.07l1.69-.62V3.2a.75.75 0 0 1 1.5 0v1.91l.21-.08a.751.751 0 0 1 .52 1.41Z';
const draw24px =
  'M22.73,9l-2,.71V20a.75.75,0,0,1-1.5,0V10.2l-3.83,1.37V20a.75.75,0,0,1-1.5,0V12.11l-3.84,1.38V20a.75.75,0,0,1-1.5,0V14L4.75,15.4V20a.75.75,0,0,1-1.5,0V15.94l-1.45.52a.69.69,0,0,1-.25,0,.74.74,0,0,1-.7-.5.75.75,0,0,1,.45-1l2-.7V4a.75.75,0,0,1,1.5,0v9.8l3.83-1.37V4a.75.75,0,0,1,1.5,0v7.89l3.84-1.37V4a.75.75,0,0,1,1.5,0v6L19.25,8.6V4a.75.75,0,0,1,1.5,0V8.07l1.47-.53a.75.75,0,0,1,1,.46A.73.73,0,0,1,22.73,9Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TallyMarksIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'tallyMarks'),
) as IconWithRender;

TallyMarksIcon.displayName = 'TallyMarksIcon';
TallyMarksIcon.propTypes = Icon.propTypes;
TallyMarksIcon.renderIcon = (props) => <TallyMarksIcon {...props} />;
export default TallyMarksIcon;
